/**
 * Mirrors Auth/PermissionCatalog.cs's preset key lists.
 *
 * The permission-catalog endpoint returns each preset's id, label, and
 * description — not its keys, since the server resolves `presetTemplate` on
 * save rather than trusting a client-supplied key list. But the picker needs
 * to preview what a preset grants *before* saving, so the key lists are
 * duplicated here. Keep this in sync with the server by hand if the catalog
 * changes — the same trade-off the original vanilla-JS app made intentionally
 * for the same reason.
 */
export const PRESET_KEYS: Record<string, readonly string[]> = {
  staff_default: [
    'medicines.view',
    'sales.view',
    'sales.create',
    'purchases.view',
    'suppliers.view',
    'customers.view',
    'reports.sales',
  ],
  pharmacist: [
    'medicines.view',
    'medicines.create',
    'medicines.edit',
    'medicines.adjust_stock',
    'sales.view',
    'sales.create',
    'sales.discount',
    'purchases.view',
    'purchases.receive',
    'suppliers.view',
    'suppliers.manage',
    'customers.view',
    'customers.manage',
    'reports.sales',
    'reports.inventory',
    'reports.expiry',
    'ocr.use',
  ],
  // "manager" is everything except users.manage — resolved against the live
  // catalog at call time rather than listed here, so it can't drift if a new
  // permission is added to the catalog and this file isn't updated.
};
